import React, { useState, useEffect } from 'react';
import {
  HiOutlineAcademicCap, HiOutlineUsers, HiOutlineLightBulb, HiOutlineGlobe,
  HiOutlineAnnotation, HiOutlineArchive, HiOutlineArrowCircleUp, HiOutlineBadgeCheck, HiOutlineBeaker,
  HiOutlineBell, HiOutlineBookOpen, HiOutlineBriefcase, HiOutlineCalendar, HiOutlineChartBar,
  HiOutlineChat, HiOutlineClipboardCheck, HiOutlineCloud, HiOutlineCode, HiOutlineCog, HiOutlineCollection,
  HiOutlineCurrencyDollar, HiOutlineDeviceMobile, HiOutlineDocumentText, HiOutlineEmojiHappy, HiOutlineExclamation,
  HiOutlineEye, HiOutlineFire, HiOutlineFlag, HiOutlineGift, HiOutlineHeart, HiOutlineKey, HiOutlineLibrary,
  HiOutlineLightningBolt, HiOutlineLocationMarker, HiOutlineLockClosed, HiOutlineMail, HiOutlineMap,
  HiOutlineMicrophone, HiOutlineMoon, HiOutlineMusicNote, HiOutlinePaperAirplane, HiOutlinePencilAlt,
  HiOutlinePhotograph, HiOutlinePresentationChartBar, HiOutlinePuzzle, HiOutlineScale,
  HiOutlineShieldCheck, HiOutlineSparkles, HiOutlineStar, HiOutlineSun, HiOutlineSupport, HiOutlineSwitchHorizontal,
  HiOutlineTerminal, HiOutlineThumbUp, HiOutlineTranslate, HiOutlineTrendingUp, HiOutlineTruck, HiOutlineUserGroup
} from 'react-icons/hi';
import './CongressObjectives.css';
import { objectivesService } from '../services/objectivesService';
import { supabase } from '../supabaseClient';
import iconOptionsRaw from '../assets/iconOptions.json';

const iconComponentMap = {
  HiOutlineAcademicCap,
  HiOutlineUsers,
  HiOutlineLightBulb,
  HiOutlineGlobe,
  HiOutlineAnnotation,
  HiOutlineArchive,
  HiOutlineArrowCircleUp,
  HiOutlineBadgeCheck,
  HiOutlineBeaker,
  HiOutlineBell,
  HiOutlineBookOpen,
  HiOutlineBriefcase,
  HiOutlineCalendar,
  HiOutlineChartBar,
  HiOutlineChat,
  HiOutlineClipboardCheck,
  HiOutlineCloud,
  HiOutlineCode,
  HiOutlineCog,
  HiOutlineCollection,
  HiOutlineCurrencyDollar,
  HiOutlineDeviceMobile,
  HiOutlineDocumentText,
  HiOutlineEmojiHappy,
  HiOutlineExclamation,
  HiOutlineEye,
  HiOutlineFire,
  HiOutlineFlag,
  HiOutlineGift,
  HiOutlineHeart,
  HiOutlineKey,
  HiOutlineLibrary,
  HiOutlineLightningBolt,
  HiOutlineLocationMarker,
  HiOutlineLockClosed,
  HiOutlineMail,
  HiOutlineMap,
  HiOutlineMicrophone,
  HiOutlineMoon,
  HiOutlineMusicNote,
  HiOutlinePaperAirplane,
  HiOutlinePencilAlt,
  HiOutlinePhotograph,
  HiOutlinePresentationChartBar,
  HiOutlinePuzzle,

  HiOutlineScale,
  HiOutlineShieldCheck,
  HiOutlineSparkles,
  HiOutlineStar,
  HiOutlineSun,
  HiOutlineSupport,
  HiOutlineSwitchHorizontal,
  HiOutlineTerminal,
  HiOutlineThumbUp,
  HiOutlineTranslate,
  HiOutlineTrendingUp,
  HiOutlineTruck,
  HiOutlineUserGroup
};

const iconOptions = iconOptionsRaw.map(opt => ({
  ...opt,
  component: iconComponentMap[opt.value] ? React.createElement(iconComponentMap[opt.value]) : <HiOutlineLightBulb />
}));

function CongressObjectives({ edition: customEdition }) {
  const [objectivesData, setObjectivesData] = useState({
    objectivesHeader: {
      title: 'Nos Objectifs',
      subtitle: ''
    },
    objectives: []
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadObjectivesData();
  }, [customEdition]);

  const loadObjectivesData = async () => {
    try {
      setLoading(true);
      
      let editionYear = customEdition;
      if (!editionYear) {
        // Get active edition first
        const { data: activeEdition, error: editionError } = await supabase
          .from('editions')
          .select('year')
          .eq('is_active', true)
          .single();
        editionYear = activeEdition?.year || '2025';
      }

      const data = await objectivesService.getObjectivesData(editionYear);

      if (data) {
        setObjectivesData(data);
      }
      setError(null);
    } catch (error) {
      setError('Failed to load objectives data');
    } finally {
      setLoading(false);
    }
  };

  const getIconComponent = (iconName) => {
    const iconOption = iconOptions.find(option => option.value === iconName);
    return iconOption ? iconOption.component : <HiOutlineLightBulb />;
  };

  if (loading) {
    return (
      <div className="congress-objectives-page">
        <div className="congress-objectives-container">
          <div className="objectives-header">
            <h1>Chargement...</h1>
            <p>Chargement des objectifs en cours...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="congress-objectives-page">
      <div className="congress-objectives-container">
        <div className="objectives-header">
          <h1>{objectivesData.objectivesHeader.title}</h1>
          <p>{objectivesData.objectivesHeader.subtitle}</p>
        </div>

        <div className="objectives-content">
          {objectivesData.objectives.length > 0 ? (
            <div className="objectives-grid">
              {objectivesData.objectives.map((objective) => (
                <div key={objective.id} className="objective-card">
                  <div className="objective-icon">
                    {getIconComponent(objective.icon)}
                  </div>
                  <div className="objective-content">
                    <h3>{objective.title}</h3>
                    <p>{objective.description}</p>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="no-objectives-message">
              <p>Aucun objectif disponible pour le moment.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default CongressObjectives;

